import { render, staticRenderFns } from "./BankAccountCreate.vue?vue&type=template&id=216c87a2"
import script from "./BankAccountCreate.vue?vue&type=script&lang=js"
export * from "./BankAccountCreate.vue?vue&type=script&lang=js"
import style0 from "./BankAccountCreate.vue?vue&type=style&index=0&id=216c87a2&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('216c87a2')) {
      api.createRecord('216c87a2', component.options)
    } else {
      api.reload('216c87a2', component.options)
    }
    module.hot.accept("./BankAccountCreate.vue?vue&type=template&id=216c87a2", function () {
      api.rerender('216c87a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinancialManagementNew/components/BankAccountCreate.vue"
export default component.exports